import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './LandingPage';
import InvitePage from './InvitePage';
import JoinPage from './JoinPage';
import PrivacyPage from './PrivacyPage';
import AccountDeletionPage from './AccountDeletionPage';
import EmailVerificationPage from './EmailVerificationPage';
import PasswordResetPage from './PasswordResetPage';
import DashboardPage from './DashboardPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/invite" element={<InvitePage />} />
        <Route path="/join/:joinCode" element={<JoinPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/delete-account" element={<AccountDeletionPage />} />
        <Route path="/verify-email" element={<EmailVerificationPage />} />
        <Route path="/reset-password" element={<PasswordResetPage />} />
        <Route path="/dashboard" element={<DashboardPage />} />
      </Routes>
    </Router>
  );
}

export default App;
